import { render } from "./other-institutions.vue?vue&type=template&id=f23ddcd0"
import script from "./other-institutions.vue?vue&type=script&lang=js"
export * from "./other-institutions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__